import { PAYMENT_METHODS_CODES } from 'js/hooks/socket/constants';

export enum PAYMENT_METHODS_LIST_VIEW {
    LIST = 'list',
    TILES = 'tiles',
    SLIDER = 'slider',
    ACCORDION = 'accordion',
    LEFT_SIDE_MENU = 'leftSideMenu'
}

export const CREDIT_CARD = 'creditCard';

export const NUVEI_REAL_CARD = 'NuveiRealCard';

export const WITHDRAW_REDIRECT_OFFER_ACC = 'redirect_suggest_previous_account';

export const SKIPPED_SUB_METHODS = [PAYMENT_METHODS_CODES.DOTPAY_BANK_TRANSFER];

export const RESERVED_FIELDS = {
    AMOUNT: 'amount',
    PROMO_CODE: 'promoCode',
    ACCOUNT_CODE: 'accountCode',
    CONVERTED_CURRENCY: 'convertedCurrency',
    STORED_ACCOUNT_ID: 'storedAccountId'
};

// region Generic field types

export const IBAN_FIELD = 'IBAN';

export enum CUSTOM_FIELDS {
    AGREEMENT_FIELD = 'BAvalue',
    UUID = 'uuid'
}

export enum IMS_CHECKBOX_FIELD_VALUE {
    CHECKED = '1',
    UNCHECKED = '0'
}

// endregion

// region Action
export enum INITIATORS {
    CASHIER = 'cashier_react'
}

export enum CONFIRMATION_FIELDS {
    LOSE_BONUS = 'loseBonus',
    FEE_CONFIRMED = 'feeConfirmed',
    DEPOSIT_CONFIRMED = 'depositConfirmed',
    CURRENCY_CONVERSION = 'currencyConversion',
    PROFIT_TAX_CONFIRMED = 'profitTaxConfirmed',
    BENEFICIAL_OWNER_CONFIRMED = 'beneficialOwnerConfirmed'
}

export const KNOWN_ERRORS = [
    {
        code: 'PAYMENTS-1012',
        type: CONFIRMATION_FIELDS.LOSE_BONUS
    },
    {
        code: 'PAYMENTS-1025',
        type: CONFIRMATION_FIELDS.FEE_CONFIRMED
    },
    {
        code: 'PAYMENTS-1027',
        type: CONFIRMATION_FIELDS.DEPOSIT_CONFIRMED
    },
    {
        code: 'PAYMENTS-1028',
        type: CONFIRMATION_FIELDS.CURRENCY_CONVERSION
    },
    {
        code: 'PAYMENTS-1029',
        type: CONFIRMATION_FIELDS.PROFIT_TAX_CONFIRMED
    },
    {
        code: 'PAYMENTS-1043',
        type: CONFIRMATION_FIELDS.BENEFICIAL_OWNER_CONFIRMED
    }
];

export const PAY_SAFE_ERROR = 'PAYMENTS-1044';

export const DOTPAY_BLIK_ERRORS = {
    ACC_CONFIRMATION_REQUIRED: 'PAYMENTS-1040',
    BLIK_CODE_NEEDED: 'PAYMENTS-1041'
};

export const SECURE_FIELDS = ['cvv', 'cvv1', 'cvv2', 'cvv3'];

export enum POST_MESSAGE_ERRORS {
    REDIRECT_WINDOW_CLOSED = 'REDIRECT_WINDOW_CLOSED',
    LIGHTBOX_CLOSED = 'LIGHTBOX_CLOSED',
    LIGHTBOX_TIMED_OUT_10S = 'LIGHTBOX_TIMED_OUT_10S',
    LIGHTBOX_TIMED_OUT_10M = 'LIGHTBOX_TIMED_OUT_10M'
}

export enum ACTION_STATUSES {
    SUCCESS = 'success',
    ERROR = 'error',
    CANCEL = 'cancel',
    WAITING = 'waiting'
}

export enum ACTION_STATUSES_3DS {
    APPROVED = 'approved',
    DECLINED = 'declined',
    WAITING = 'waiting'
}

export const TRANSACTION_SEARCH_PARAMS = [
    'type',
    'amount',
    'action',
    'status',
    'errorCode',
    'initiator',
    'extraData',
    'requestCode',
    'redirectType',
    'datatransTrxId',
    'transactionCode'
];
// endregion
